import { RouterProvider } from '@tanstack/react-router';

import { useAuth } from '~/context/useAuth';
import { router } from '~/lib/router';

export function Router() {
	const auth = useAuth();
	return <RouterProvider router={router} context={{ auth }} />;
}
